import { getIvaToDisplay } from '../../lib/IVAUtils'

export default ({ iva }) => (
  <span>
    { getIvaToDisplay(iva) }
  </span>
)